import React from 'react';
import { partial } from 'lodash';

import Box from 'components/Box';
import Text from 'components/Text';

const LevelItem = ({ value, level, label, handleChange, className }) => (
  <Box
    bg={level === value ? 'primary050' : 'white'}
    pv={6}
    ph={8}
    bradius={4}
    b
    pointer
    mr={8}
    className={className}
    onClick={partial(handleChange, 'level', value)}
  >
    <Text fs14 fw600 violetXdark i18n={`entities.${label}`} />
  </Box>
);

export default LevelItem;
